export const DESIGN_SESSION_STATUS = [
  "needs_clarification",
  "ready_to_generate",
];

export const KITCHEN_DESIGN_SESSION_SCHEMA = {
  type: "object",
  additionalProperties: false,
  required: ["status", "summary", "known", "missing", "questions"],
  properties: {
    status: {
      type: "string",
      enum: DESIGN_SESSION_STATUS,
    },

    summary: {
      type: "string",
    },

    known: {
      type: "object",
    },

    missing: {
      type: "array",
      items: {
        type: "string",
      },
    },

    questions: {
      type: "array",
      items: {
        type: "object",
        additionalProperties: false,
        required: ["key", "question"],
        properties: {
          key: {
            type: "string",
          },

          question: {
            type: "string",
          },

          options: {
            type: "array",
            items: {
              type: "string",
            },
          },
        },
      },
    },

    assumptions: {
      type: "array",
      items: {
        type: "string",
      },
    },

    nextPrompt: {
      type: "string",
    },
  },
};